import { makeStyles } from "@material-ui/styles";

const settingConfirmationListItemStyles = makeStyles(() => ({
	sectionText: {
		fontWeight: "bold"
	},
	changeList: { marginLeft: "20px" }
}));

export default settingConfirmationListItemStyles;
